export default "__VITE_ASSET__qQXfaEwd__"